module.exports = __webpack_public_path__ + "img/signup-guide-01-04.ba510a98.png";